/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assign_Driver_Badge_FreeInputs */

const vi_assign_driver_badge_free = /** @type {(inputs: Assign_Driver_Badge_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang rảnh`)
};

/**

* @param {Assign_Driver_Badge_FreeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const assign_driver_badge_free = /** @type {((inputs?: Assign_Driver_Badge_FreeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assign_Driver_Badge_FreeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_assign_driver_badge_free(inputs)
});